import { clsx } from "@trydig/ui";
import { Asset } from "@/components/ui/Asset";
import { Typography } from "@/components/ui/Typography";
import type { AssetStoryblok } from "@/generated/sb/sb-types";

export interface FigureProps {
	asset?: AssetStoryblok;
	containerClassName?: string;
	mediaClassName?: string;
}

export const Figure = ({ asset, containerClassName, mediaClassName }: FigureProps) => {
	return (
		<figure className={clsx("flex flex-col gap-grid-section-vertical-sm", containerClassName)}>
			<div className={clsx("relative w-full overflow-hidden", mediaClassName)}>
				<Asset asset={asset} sizes="(min-width: 1024px) 50vw, 100vw" />
			</div>
			{asset?.title && (
				<figcaption>
					<Typography variant="body-xs-reg" className="text-text-dark-text-2">
						{asset.title}
					</Typography>
				</figcaption>
			)}
		</figure>
	);
};
